import config from 'configDir/index';
import { get } from './http';

// 查询黑名单
const queryPractitionerService = get('/practitioner/queryPractitioner', config.resourceUrl);

// 报警趋势
const alarmTrendService = get('/alarmPanelStatistical/alarmTrend', config.serviceUrl);

// 历史违章频发时段
const statViolationTrendService = get(
  '/violation/overview/stat_violation_trend',
  config.governanceUrl,
);

export {
  // eslint-disable-next-line import/prefer-default-export
  queryPractitionerService,
  alarmTrendService,
  statViolationTrendService,
};
